import React from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import useWatchFormFieldsChanges from 'components/common/form/hooks/useWatchFormFieldsChanges';

export default function ConciergeForm(props: IFormLayoutProps) {
    useWatchFormFieldsChanges(
        props.hookForm.form,
        [
            'exclude_help_docs',
            'include_glossary_ind',
            'llm_custom_faq_dataset_id',
            'llm_custom_faq_question_column_id',
            'llm_custom_faq_answer_column_id',
            'llm_custom_faq_scope',
            'llm_custom_faq_include_portal_name',
        ],
        'update_index_alert_status',
    );
    return <FormLayoutComposer props={{ ...props }} />;
}
